<template>
    
    <div>    
       <!--  <p>Id ES {{$route.params.id}}</p> -->
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a>
                    <router-link :to="{name:'r-/'}">Inicio</router-link>
                </a></li>
                <li class="breadcrumb-item active" aria-current="page">Productos</li>
                <li class="breadcrumb-item active" aria-current="page">
                    <span style="text-shadow">Todos</span>
                </li>
            </ol>
        </nav>
        <div>
            <div class="row">
                <div class="col-12 mt-4">
                    <div class="card">
                        <div class="card-body" style="display:flex; flex-wrap: wrap;">
                            <div style="width: 100%; display:flex; justify-content:center;">
                                <button type="button" class="boton-3d-success" @click=boton_modal_registro>
                                    Nuevo producto
                                </button>
                            </div>       
                            <div v-if="datos.data_table.cargando" class="d-flex justify-content-center" style="width:100%; margin-top:1em; margin-bottom:1em; color:white;">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>     
                            <div id="contenedor-tabla-registros" style="width: 100%;"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>




        <!-- inicio modal registro -->
        <div class="modal fade bd-example-modal-lg" id="modal-registro">
            <div class="modal-dialog modal-lg">
                <div class="modal-content modal-3d">
                    <div class="modal-header">
                        <h5 v-if="datos.registro.id===''" class="modal-title">Crear producto</h5>
                        <h5 v-else class="modal-title">Editar producto</h5>
                        <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <div v-if="datos.registro_cargando" class="d-flex justify-content-center" style="width:100%; margin-top:1em; margin-bottom:1em; color:black;">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div class="form-row">  
                                     
                                <div class="form-group col-md-12">
                                    <label for="inputEmail4">Nombre</label>
                                    <input type="text" class="form-control input-3d" v-model=datos.registro.nombre>
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="inputEmail4">Categoria</label>
                                    <select class="form-control input-3d" v-model=datos.registro.categorias_id>
                                        <option value="" disabled>Seleccione</option>
                                        <option v-for='(categorias,categorias_index) in datos.categorias.todos' :key=categorias_index :value=categorias.id>
                                            {{ categorias.nombre }}
                                        </option>
                                    </select>
                                </div>
                                <!---<div class="form-group col-md-4">
                                    <label for="inputEmail4">Mostrar en compra</label>
                                    <input type="checkbox" class="form-control" v-model=datos.registro.mostrar_en_compra>                                    
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="inputEmail4">Mostrar en venta</label>
                                    <input type="checkbox" class="form-control" v-model=datos.registro.mostrar_en_venta>                                    
                                </div>-->
                                <!--<div class="form-group col-md-4">
                                    <label for="inputEmail4">Lleva relación</label>
                                    <input type="checkbox" class="form-control" v-model=datos.registro.lleva_relacion>                                    
                                </div>-->
                                                                                                                                                  
                            </div>                          
                        </div>
                    </div>
                    <div class="modal-footer" v-if="!datos.registro_cargando">
                        <button type="button" class="boton-3d-success" @click="enviar_datos">
                            <template v-if="datos.registro.id===''">
                                Crear
                            </template>
                            <template v-else>
                                Editar
                            </template>
                        </button>
                        
                        <button type="button" class="boton-3d-danger" data-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
        <!---fin modal registro---->

        <!-- inicio modal precio -->
        <div class="modal fade bd-example-modal-lg" id="modal-precio">
            <div class="modal-dialog modal-lg">
                <div class="modal-content modal-3d">
                    <div class="modal-header">
                        <h5 class="modal-title">Precio de</h5>
                        <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <div v-if="datos.registro_precio.cargando" class="d-flex justify-content-center" style="width:100%; margin-top:1em; margin-bottom:1em; color:black;">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div class="form-row">                                                                       

                                <div class="form-group col-md-12" style="height:280px; overflow:scroll;" v-if="datos.registro_precio.historial.length>0">
                                    <label for="inputEmail4">Historial de precios</label>
                                    <table class="table table-hover">
                                        <thead>
                                            <tr>
                                                <th scope="col"></th>
                                                <th scope="col"></th>
                                                <th scope="col"></th>
                                                <th scope="col" colspan="2" style="text-align:center;">Fecha</th>
                                            </tr>
                                            <tr>
                                                <th scope="col">#</th>
                                                <th scope="col"></th>
                                                <th scope="col">Precio</th>
                                                <th scope="col">Inicial</th>
                                                <th scope="col">Final</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for='(item,index) in datos.registro_precio.historial' :key=index>
                                                <th scope="row">{{index+1}}</th>
                                                <td>
                                                    <template v-if="item.estado==='activo'">
                                                        Actual
                                                    </template>
                                                </td>
                                                <td>$ {{item.precio}}</td>
                                                <td>{{item.fecha_inicial}}</td>
                                                <td>{{item.fecha_final}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="inputEmail4">Nuevo Precio</label>
                                    <input type="number" class="form-control input-3d" v-model=datos.registro_precio.precio>
                                </div>
                                                                                                                                                  
                            </div>                          
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="boton-3d-success" @click="precio_enviar_datos">
                            Guardar nuevo precio
                        </button>
                        
                        <button type="button" class="boton-3d-danger" data-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
        <!---fin modal registro---->

        <!-- inicio modal vinculados -->
        <div class="modal fade bd-example-modal-lg" id="modal-vinculados">
            <div class="modal-dialog modal-lg">
                <div class="modal-content modal-3d">
                    <div class="modal-header">
                        <h5 class="modal-title">Productos vinculados</h5>
                        <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <div v-if="datos.registro_cargando" class="d-flex justify-content-center" style="width:100%; margin-top:1em; margin-bottom:1em; color:black;">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div class="form-row">                                                                       
                                <div class="form-group col-md-12">
                                    <!---<label for="inputEmail4">Categoria</label>-->
                                    <button class='boton-3d-success' type="button" @click="agregar_producto_vinculado('')" v-if="!datos.registro_cargando">
                                        <i class='fa fa-plus' aria-hidden='true'></i>
                                    </button>
                                    <div style="width:100%;">
                                        <template v-for='(p,p_index) in datos.registro_vinculados.productos'>

                                            <div v-if="p.estado=='activo'" :key=p_index class="form-row">

                                                <div class="form-group col-md-1">
                                                    <p style="width:30px; margin-rith:">{{ p.posicion }} - </p>
                                                </div>

                                                <div class="form-group col-md-10">
                                                    <select class='form-control input-3d' v-model=p.producto_vinculado>
                                                        <option value='' disabled>Seleccione</option>
                                                        <option v-for='(p2,p2_index) in datos.productos.todos' :value=p2.id :key=p2_index>
                                                            {{ p2.nombre }}
                                                        </option>   
                                                    </select>
                                                </div>

                                                <div class="form-group col-md-1">
                                                    <button class='boton-3d-danger' type="button" @click="remover_producto_vinculado(p_index)">
                                                        <i class='fa fa-times' aria-hidden='true'></i>
                                                    </button>
                                                </div>


                                            </div>

                                        </template>
                                    </div>
                                    <!-- <select class="form-control input-3d" v-model=datos.registro.categorias_id>
                                        <option value="" disabled>Seleccione</option>
                                        <option v-for='(categorias,categorias_index) in datos.categorias.todos' :key=categorias_index :value=categorias.id>
                                            {{ categorias.nombre }}
                                        </option>
                                    </select> -->
                                </div>
                                                                                                                                                  
                            </div>                          
                        </div>
                    </div>
                    <div class="modal-footer" v-if="!datos.registro_cargando">
                        <button type="button" class="boton-3d-success" @click="enviar_datos_vinculados">
                            <template v-if="datos.registro.id===''">
                                Crear
                            </template>
                            <template v-else>
                                Editar
                            </template>
                        </button>
                        
                        <button type="button" class="boton-3d-danger" data-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
        <!---fin modal vinculados---->


    </div>

</template>

<script>
/* eslint-disable */
import { mapState } from 'vuex'
import { mapMutations } from 'vuex'
import Swal   from '@/librerias/sweetalert2_9/sweetalert2_9.js'
import * as calculos  from '@/librerias/lobato-calculos.js'

export default {
    name: 'com_general',
    props: {
        msg: String
    },
    data() {
    return {
        datos:{
            registro_cargando:false,
            registro:{
                id:'',
                nombre:'',
                categorias_id:'',
                mostrar_en_venta:false,
                mostrar_en_compra:false,
                lleva_relacion:false
            },
            data_table:{
                cargando:false,
                registros:[]
            },
            categorias:{
                seleccionado_cargando:false,
                todos:[],
                seleccionado:''                
            },
            productos:{
                todos:[]
            },
            registro_precio:{
                id:'',
                precio:'',
                historial:[],
                cargando:false
            },
            registro_vinculados:{
                productos:[]
            }
        }/* ,
        general:{
            otros:{
                dominio:location.origin,
                csrf:''
            }
        } */
    }
    },
    mounted(){
        this.inicial();
    },
    methods:{
        ...mapMutations(['funciones','alerta']),  
        inicial()
        {
            if(this.general.otros.autenticado===true)
            {
                this.obtener_recursos();
                this.data_table();
            }
            else if(this.general.otros.autenticado===false)
            {
                this.$router.push('/login');
            }
        }, 
        obtener_recursos()
        {
            //fetch(`${this.general.otros.dominio_server}/productos/recursos`)
            fetch(`${this.general.otros.dominio_server}/productos/recursos`,{
                method:'GET',
                //body:JSON.stringify( this.datos.registro ),
                headers:{
                    'Accept'        :'application/json',
                    'Content-Type'  :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                },
                credentials: 'include'
            })
            .then(res=>res.json())
            .then(respuesta=>{
                
                console.log('recursos');
                console.log(respuesta);
                this.datos.categorias.todos =respuesta.datos.categorias;
                this.datos.productos.todos  =respuesta.datos.productos;

            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse los recursos`});
            })
            .finally( () => {
                //this.datos.data_table.cargando=false;                
            });
        },        
        boton_modal_registro()
        {
            for (const p in this.datos.registro) {    
                /* if(p=='imagen')                            
                {
                    this.datos.registro[p].archivo='';
                    this.datos.registro[p].url='';
                }
                else if(p=='categorias')
                {
                    this.datos.registro[p]=[];
                } */
                if(p=='mostrar_en_compra')
                {
                    this.datos.registro[p]=false;
                }
                else if(p=='mostrar_en_venta')
                {
                    this.datos.registro[p]=false;
                }
                else if(p=='lleva_relacion')
                {
                    this.datos.registro[p]=false;
                }
                else
                {
                    this.datos.registro[p]='';
                }
            }
            this.funciones({nombre:'sonido',sonido:this.general.sonidos.abrir});
            $("#modal-registro").modal("show");
        },
        data_table()
        {
            this.datos.data_table.cargando=true;            
            //fetch(`${this.general.otros.dominio_server}/productos/todos`)
            fetch(`${this.general.otros.dominio_server}/productos/todos`,{
                method:'GET',
                //body:JSON.stringify( this.datos.registro ),
                headers:{
                    'Accept'        :'application/json',
                    'Content-Type'  :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                },
                credentials: 'include',                   
            })
            .then(res=>res.json())
            .then(respuesta=>{
                
                this.datos.data_table.registros=respuesta.datos;                
                this.data_table_crear();
            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse los productos`});
            })
            .finally( () => {
                this.datos.data_table.cargando=false;                
            });
        },
        data_table_crear()
        {
            document.getElementById('contenedor-tabla-registros').innerHTML=`
                <table id="tabla-registros" class="table table-hover w-100 pb-30">
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Categoria</th>
                            <th>Nombre</th>
                            <th style="width:15%;">Precio actual</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody >
                    </tbody>
                    <tfoot>
                        <tr>
                            <th>Id</th>
                            <th>Categoria</th>
                            <th>Nombre</th>
                            <th style="width:15%;">Precio actual</th>
                            <th>Acciones</th>
                        </tr>
                    </tfoot>
                </table>
            `;
            $('#tabla-registros thead tr').clone(true).appendTo( '#tabla-registros thead' );
            $('#tabla-registros thead tr:eq(1) th').each( function (i) {
                var title = $(this).text();
                $(this).html( '<input class="form-control" style="width:100%;font-size:11px;" type="text" placeholder="Buscar '+title+'" />' );
        
                $( 'input', this ).on( 'keyup change', function () {
                    if ( tabla_registros.column(i).search() !== this.value ) {
                        tabla_registros
                            .column(i)
                            .search( this.value )
                            .draw();
                    }
                } );
            } );
            
            var tabla_registros=$('#tabla-registros').DataTable({
                orderCellsTop: true,
                fixedHeader: true,
                responsive: true,
                autoWidth: true,
                "order":[0,'desc'],
                language: {
                    search: "Buscar",
                    searchPlaceholder: "Buscar",
                    lengthMenu: "Mostrando _MENU_ registros por página",
                    zeroRecords: "No se encontraron registros",
                    info: "Mostrando pagina _PAGE_ de _PAGES_",
                    infoEmpty: "No hay registros disponibles",
                    infoFiltered: "(filtrando de _MAX_ registros)",
                    paginate: {
                        "first":      "First",
                        "last":       "Last",
                        next:       "Siguiente",
                        previous:   "Anterior"
                    },
                },
                //ajax:`/ordenes_elaboracion_materiales/todos`,
                //ajax:`/clientes/todos`,
                data:this.datos.data_table.registros,                
                columnDefs:[  
                    {"targets":0, "data":(data,type,full,meta)=>
                        {                            
                            return data.id;
                        }   
                    },                  
                    {"targets":1, "data":(data,type,full,meta)=>
                        {                            
                            return data.categoria;
                        }   
                    },
                    {"targets":2, "data":(data,type,full,meta)=>
                        {                            
                            return data.nombre;
                        }   
                    },
                    {"targets":3, "data":(data,type,full,meta)=>
                        {                      
                            let p=calculos.revisar_entrada(data.precio);
                            return `$ ${p}`;
                        }   
                    },
                    {"targets":4, "data":(data,type,full,meta)=>
                        {
                            var acciones=``;

                            acciones+=`
                                <button registro-id='${data.id}' class="boton-modal-editar-registro boton-3d-info" style="margin-right:1em;">
                                    <i registro-id='${data.id}' class="fa fa-pencil-square-o" aria-hidden="true"></i>
                                    Editar
                                </button>
                                <button registro-id='${data.id}' class="boton_modal_precio boton-3d-info" style="margin-right:1em;">
                                    <i registro-id='${data.id}' class="fa fa-money" aria-hidden="true"></i>
                                    Precio
                                </button>     
                                <button registro-id='${data.id}' class="boton-modal-remover boton-3d-danger" style="margin-right:1em;">
                                    <i registro-id='${data.id}' class='fa fa-times' aria-hidden='true'></i>                                    
                                </button>                          
                            `;
                            /*if(data.lleva_relacion=='si')
                            {
                                acciones+=`
                                    <button registro-id='${data.id}' class="boton_modal_vinculados boton-3d-info" style="margin-right:1em;">                                    
                                        Vinculados
                                    </button>                                
                                `;
                            }*/

                            return `
                                <div style="display:flex; justify-content:left;">
                                    ${acciones} 
                                </div>
                            `;
                        }
                    }
                ],
                "drawCallback": this.eventos_data_table
            });
            tabla_registros.on( 'responsive-display',  ( e, datatable, row, showHide, update ) => {               
                this.eventos_data_table();
            } );
            
        },
        eventos_data_table()
        {
            Array.from(document.getElementsByClassName("boton-modal-editar-registro")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_editar_registro_evento);
            });

            Array.from(document.getElementsByClassName("boton_modal_precio")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_precio);
            });
            
            /* Array.from(document.getElementsByClassName("boton-modal-eliminar")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_eliminar);
            }); */
            Array.from(document.getElementsByClassName("boton-modal-remover")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_remover);
            });

            Array.from(document.getElementsByClassName("boton_modal_vinculados")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_vinculados);
            });
        },
        boton_modal_remover(item)
        {
            //this.datos.registro.i
            let dt={
                id:calculos.atributo(item,'registro-id')//,
                //no:calculos.atributo(item,'registro-no')
            };
            Swal.fire({
                title: `¿ Remover producto id : ${dt.id} ?`,
                text: "",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Si, remover ahora",
                cancelButtonText:'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) 
                {
                    this.alerta({titulo:'Procesando datos',mensaje:'espere ...'});  
                    fetch(`${this.general.otros.dominio_server}/productos/registro/remover`,{
                        method:'POST',
                        body:JSON.stringify( {
                            productos_id:dt.id,
                        } ),
                        headers:{                    
                            //'X-CSRF-TOKEN':this.general.otros.csrf
                            'Content-Type'  :'application/json',
                            'Accept'        :'application/json',
                            //'Authorization' :`Bearer ${this.general.otros.token}`
                        },
                        credentials: 'include',                   
                    })
                    //.then(res=>res.json())
                    .then(res => {
                        //console.log(res);
                        //console.log('Estado de la respuesta:', res.status);
                        if (res.status == 200) 
                        {
                            return res.json();
                        }
                        else
                        {
                            throw new Error(`Error: ${res.status}`);
                        }

                        //return res.json();
                    })
                    .then(respuesta=>{
                        let dt={
                            'bien':()=>{                        
                                this.data_table();
                                $("#modal-registro").modal("hide");
                                this.funciones({nombre:'alerta',estatus:'success',mensaje:`Producto removido`});
                            }
                        };

                        if(respuesta.mensaje in dt )
                        {
                            dt[respuesta.mensaje]();
                        }                
                    })
                    .catch(error=>{
                        this.funciones({nombre:'alerta',estatus:'error',mensaje:`El producto no se pudo remover`});
                    })
                    .finally( () => {
                        //this.datos.data_table.cargando=false;
                    });
                }
            });
        },
        boton_modal_vinculados(item)
        {
            this.datos.registro.id=calculos.atributo(item,'registro-id');
            this.datos.registro_vinculados.productos=[];    
            this.datos.registro_cargando=true;                  
            this.funciones({nombre:'sonido',sonido:this.general.sonidos.abrir});
            $("#modal-vinculados").modal("show");
            fetch(`${this.general.otros.dominio_server}/productos/${this.datos.registro.id}/vinculados`,{
                method:'get',
                //body:JSON.stringify( r ),
                //body:formdata,
                headers:{                    
                    //'Content-Type':'application/json',
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                    'Content-Type'  :'application/json',
                    'Accept'        :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                },
                credentials: 'include',                   
            })
            .then(res => {
                if (res.status == 200) 
                {
                    return res.json();
                }
                else
                {
                    throw new Error(`Error: ${res.status}`);
                }
            })
            //.then(res=>res.json())
            .then(respuesta=>{

                console.log('vinculados');
                console.log(respuesta);

                let v=respuesta.datos.vinculados;

                v.forEach((item)=>{
                    this.agregar_producto_vinculado(item);
                });

            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse los datos`});
            })
            .finally( () => {
                this.datos.registro_cargando=false;
            });

        },
        boton_modal_editar_registro_evento(item)
        {        
            this.boton_modal_registro();
            this.datos.registro.id=item.target.getAttribute('registro-id');  
            this.datos.registro_cargando=true;          
            //fetch(`${this.general.otros.dominio}/productos/${this.datos.registro.id}/datos`)
            fetch(`${this.general.otros.dominio_server}/productos/${this.datos.registro.id}/datos`,{
                method:'get',
                //body:JSON.stringify( r ),
                //body:formdata,
                headers:{                    
                    //'Content-Type':'application/json',
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                    'Content-Type'  :'application/json',
                    'Accept'        :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                },
                credentials: 'include',                   
            })
            .then(res => {
                if (res.status == 200) 
                {
                    return res.json();
                }
                else
                {
                    throw new Error(`Error: ${res.status}`);
                }
            })
            //.then(res=>res.json())
            .then(respuesta=>{

                let r=respuesta.datos[0];

                for (const p in this.datos.registro) 
                {                  
                    if(p=='mostrar_en_compra')     
                    {
                        let a=p in r ? r[p] : '';
                        this.datos.registro[p]= a==='si' ? true : false;
                    }
                    else if(p=='mostrar_en_venta')               
                    {
                        let a=p in r ? r[p] : '';
                        this.datos.registro[p]= a==='si' ? true : false;
                    }
                    else if(p=='lleva_relacion')               
                    {
                        let a=p in r ? r[p] : '';
                        this.datos.registro[p]= a==='si' ? true : false;
                    }
                    else
                    {                    
                        this.datos.registro[p]= p in r ? r[p] : this.datos.registro[p];
                    }
                }

            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse los datos`});
            })
            .finally( () => {
                this.datos.registro_cargando=false;
            });
            
        },        
        enviar_datos()
        {
            this.alerta({titulo:'Procesando datos',mensaje:'espere ...'});
                  
            let r=this.datos.registro;
            let a={
                id                  :r.id,
                nombre              :r.nombre,
                categorias_id       :r.categorias_id,
                mostrar_en_venta    :r.mostrar_en_venta ? 'si' : 'no',
                mostrar_en_compra   :r.mostrar_en_compra ? 'si' : 'no',
                lleva_relacion      :r.lleva_relacion ? 'si' : 'no'
            };

            fetch(`${this.general.otros.dominio_server}/productos/registro`,{
                method:'POST',
                body:JSON.stringify( a ),
                //body:formdata,
                headers:{                    
                    //'Content-Type':'application/json',
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                    'Content-Type'  :'application/json',
                    'Accept'        :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                },
                credentials: 'include',                   
            })
            .then(res => {
                if (res.status == 200) 
                {
                    return res.json();
                }
                else
                {
                    throw new Error(`Error: ${res.status}`);
                }
            })
            //.then(res=>res.json())
            .then(respuesta=>{
                let dt={
                    'bien':()=>{                        
                        this.data_table();
                        $("#modal-registro").modal("hide");
                        this.funciones({nombre:'alerta',estatus:'success',mensaje:`Producto ${this.datos.registro.id=='' ? 'creado' : 'editado'}`});
                    }
                };

                if(respuesta.mensaje in dt )
                {
                    dt[respuesta.mensaje]();
                }                
            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`El producto no se pudo ${this.datos.registro.id=='' ? 'crear' : 'editar'}`});
            })
            .finally( () => {
                //this.datos.data_table.cargando=false;
            });
        },
        enviar_datos_vinculados()
        {
            this.alerta({titulo:'Procesando datos',mensaje:'espere ...'});

            let a=(this.datos.registro_vinculados.productos).filter( (e)=>e.estado=='activo' || (e.estado=='inactivo' && e.id!=='') );
                                               
            fetch(`${this.general.otros.dominio_server}/productos/vinculados/registro`,{
                method:'POST',
                body:JSON.stringify( {
                    productos_id        :this.datos.registro.id,
                    productos_vinculados:a
                } ),
                //body:formdata,
                headers:{                    
                    //'Content-Type':'application/json',
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                    'Content-Type'  :'application/json',
                    'Accept'        :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                },
                credentials: 'include',                   
            })
            .then(res => {
                if (res.status == 200) 
                {
                    return res.json();
                }
                else
                {
                    throw new Error(`Error: ${res.status}`);
                }
            })
            //.then(res=>res.json())
            .then(respuesta=>{

                let dt={
                    'bien':()=>{                        
                        this.data_table();
                        $("#modal-vinculados").modal("hide");
                        this.funciones({nombre:'alerta',estatus:'success',mensaje:`Productos guardados`});
                    }
                };

                if(respuesta.mensaje in dt )
                {
                    dt[respuesta.mensaje]();
                }              

            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`Los producto no se guardaron`});
            })
            .finally( () => {
                //this.datos.data_table.cargando=false;
            });
        },
        boton_modal_precio(item)
        {
            this.datos.registro.id=calculos.atributo(item,'registro-id');
            this.datos.registro_precio.id='';
            this.datos.registro_precio.precio='';
            this.datos.registro_precio.historial=[];
            this.datos.registro_precio.cargando=true;

            fetch(`${this.general.otros.dominio_server}/productos/${this.datos.registro.id}/precios`,{
                method:'GET',
                //body:JSON.stringify( this.datos.registro ),
                headers:{
                    'Accept'        :'application/json',
                    'Content-Type'  :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                },
                credentials: 'include',                   
            })
            .then(res=>res.json())
            .then(respuesta=>{
                
                console.log('precios');
                console.log(respuesta);
                this.datos.registro_precio.historial=respuesta.datos.precios;
                //this.datos.categorias.todos=respuesta.datos.categorias;

            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse el historial`});
            })
            .finally( () => {
                this.datos.registro_precio.cargando=false;              
            });

            this.funciones({nombre:'sonido',sonido:this.general.sonidos.abrir});
            $("#modal-precio").modal('show');
        },
        precio_enviar_datos()
        {
            this.alerta({titulo:'Procesando datos',mensaje:'espere ...'});
                                               
            fetch(`${this.general.otros.dominio_server}/productos/precios/registro`,{
                method:'POST',
                body:JSON.stringify( {
                    id          :this.datos.registro_precio.id,
                    productos_id:this.datos.registro.id,
                    precio      :this.datos.registro_precio.precio
                } ),
                //body:formdata,
                headers:{                    
                    //'Content-Type':'application/json',
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                    'Content-Type'  :'application/json',
                    'Accept'        :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                },
                credentials: 'include',                   
            })
            .then(res=>res.json())
            .then(respuesta=>{
                let dt={
                    'bien':()=>{                        
                        this.data_table();
                        $("#modal-precio").modal("hide");
                        this.funciones({nombre:'alerta',estatus:'success',mensaje:`Precio ${this.datos.registro_precio.id=='' ? 'creado' : 'editado'}`});
                    }
                };

                if(respuesta.mensaje in dt )
                {
                    dt[respuesta.mensaje]();
                }                
            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`El precio no se pudo ${this.datos.registro_precio.id=='' ? 'crear' : 'editar'}`});
            })
            .finally( () => {
                //this.datos.data_table.cargando=false;
            });
        },
        agregar_producto_vinculado(r)
        {
            this.datos.registro_vinculados.productos.push({
                id                  :r=='' ? '' : r.id,
                producto_vinculado  :r=='' ? '' : r.producto_vinculado,
                posicion            :'',
                estado              :'activo'
            });
            this.productos_vinculados_ordenar_posiciones();
        },
        remover_producto_vinculado(p_index)
        {
            this.datos.registro_vinculados.productos[p_index].estado='inactivo';
            this.productos_vinculados_ordenar_posiciones();
        },
        productos_vinculados_ordenar_posiciones()
        {            
            let a=0;
            this.datos.registro_vinculados.productos.forEach((item,index)=>{
                
                if(item.estado=='activo')
                {
                    a++;
                    item.posicion=a;
                }

            });
        }
    },
    computed: {...mapState(['general']) },
    watch: {
        'general.otros.autenticado': function (v) {
            if(v)
            {
                this.inicial();
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    #contenedor-registro-imagen{
        width:100%;
        display:flex;
        justify-content: center;
        margin-top:1em;
        img{
            border-radius:7px;
        }
    }
    #contenedor-categorias-seleccionadas{
        display:flex;
        flex-wrap: wrap;
        margin-top:1em;
        p{
            margin-right: 1.5em;
            background:#c6c6f6;
            font-weight: bold;
            padding:0.5em;
            border-radius: 7px;
            cursor:pointer;
        }
    }
</style>